import { RadioProps } from '@app/types'
import { Radio as AntRadio } from 'antd'

export const Radio: React.FC<RadioProps> = (props) => <AntRadio {...props} />
